






























































import { Component, Watch, Vue, Prop, Emit } from 'vue-property-decorator'; // デコレータ
// 共通機能
import ApiAccessBase from '../../CommonFeature/components/ApiAccessBase.vue';
import router from '../../router';
// 定数ファイル
import { Constants } from '../../CommonUtils/fixed/Constants';
import { Message } from '../../CommonUtils/fixed/Message';
import { ScreenMode } from '../../CommonUtils/fixed/ScreenMode';
import { ScreenName } from '../../CommonUtils/fixed/ScreenName';
import { ApplicationChangeType} from '../fixed/ApplicationChangeType';
import { ApplicationProcessType} from '../fixed/ApplicationProcessType';
// 共通モジュール
import { supervisingModule } from '../../store/modules/OperationSupervising';
import { routingControlModule } from '@/store/modules/RoutingControl';
import { applicationFormModule } from '../store/modules/ApplicationForm';
// 個別
import { loadingControlModule } from '../../store/modules/LoadingControl';

import workTypeList from '../components/WorkTypeConfirmList.vue';
Vue.component('variableWorkTypeList', workTypeList);

// コンポーネント登録
Vue.component('ApiAccessBase', ApiAccessBase);

@Component
export default class ApplicationFormConstruction extends ApiAccessBase {

  // 処理状況
  protected statusValue: string = '';
  // 拡張パネルの設定（検索条件）
  private exPanel: number[] = [];
  private exPanelBk: number[] = [];

  // 業者種別
  private traderType = applicationFormModule.GET_APP_TYPE;
  // 共通パス
  private APP_PATH = Constants.UKETSUKE_URL + '/application/' + applicationFormModule.GET_APP_TYPE;

  private variableColNames: string[] = [];
  private GROUP_LAYOUT_ARRAY: string = Constants.GROUP_LAYOUT_ARRAY;

  private isSubmitEnd = false;

  /**
   * 初期化処理created
   */
  private created() {
    this.screenTitle = '新規/継続申請登録確認（印刷）';

    // モジュールに現在の画面を記録
    routingControlModule.registCurrent(this.$route.name);

    let path = this.APP_PATH;

    if (!applicationFormModule.IS_SET_CHANGE_TYPE) {
      // 通常の修正
      path = path + '/get_confirm/normal';
    } else {
      // 継続（修正）
      path = path + '/get_confirm/continue';
    }
    path = path + '/' + applicationFormModule.GET_TRADER_ID;

    // APIアクセス
    this.apiAccess(path, Constants.API_METHOD_GET, false, false)
    .then((result) => {
      if (result === Constants.API_RESULT_SUCCES) {
        // 使用する可変項目の設定（全て）
        this.setAllVariablecolsState();
        let panelIndex = 0;
        for (const variablecol of Object.keys(this.variablecols)) {
          if (variablecol !== 'local_info') {
            // パネル設定全オープン
            this.exPanel.push(panelIndex);
            panelIndex++;
            this.variableColNames.push(variablecol);
          }
        }
        this.exPanelBk = this.exPanel.concat();
        // 処理状況表示
        this.statusValue = '処理状況：' + this.formData.status;
        this.screenTitle += '（印刷）';
      }
    });
  }

  /**
   * 前画面に戻る
   */
  private returnPrevious() {
    router.push('appFormConfirm');
  }

  /**
　  * 印刷
　  */
  private screenPrint() {
    window.print();
  }
}
